import map from "ramda/es/map";
import createArrayRowValidations$ from '../feature/arrayRowValidations';
import createArrayValidationSynchronizer$ from '../feature/arrayValidationSynchronizer';
import createAsyncValidations$ from '../feature/asyncValidations';
import createClearFieldsErrors$ from '../feature/clearFieldsErrors';
import createFieldArrayValidation$ from '../feature/fieldArrayValidation';
import createFormValidation$ from '../feature/formValidation';
import createManualFocus$ from '../feature/manualFocus';
import createManualValidationInsert$ from '../feature/manualValidationInsert';
import createMultipleFieldValidation$ from '../feature/multipleFieldValidations';
import createSingleFieldValidation$ from '../feature/singleFieldValidation';
import createFormData$ from '../state/formData';
import createFormDescriptor$ from '../state/formDescriptor';
import createFormFieldState$ from '../state/formFieldState';
import createFormState$ from '../state/formState';
import createGlobalErrors$ from '../state/globalErrors';
import createControl$ from '../transfer/control';
import createTransmission$ from '../transfer/transmission';
// nevim jestli se podari udrzet streamy takto separovane.
// protoze bude napr. potreba mergnout formDescriptor$ s formData$. Ale to ted neudelame takto. To se pak bude muset nasledne pomergovat apod
// nebo kdyz budeme chtit modifikovat action. zrejme je to takto naivni implementace zatim. muzou zde vzniknout cyklicke zavislosti ve streamech.
// Urcite by ale nemelo byt mozne aby vznikla cyklicka zavislost mezi akcema. Nedavalo by to zrejme ani smysl.
// Ale principialne muzeme mit stream co mergne dva streamy a vytvori z toho novou akci zase na zacatek controllu
export default (({ formDescriptor, reduxStore, name }, streamExtension = {}, preservedState)=>{
    const { formDataExtension, formFieldStateExtension, globalErrorsExtension, featuresExtension = [], transmissionExtension, formStateExtension } = streamExtension;
    const control$ = createControl$();
    const formDescriptor$ = createFormDescriptor$({
        formDescriptor
    });
    const formData$ = createFormData$({
        control$,
        formDescriptor$
    }, formDataExtension, preservedState.formData$);
    const formFieldState$ = createFormFieldState$({
        control$,
        formDescriptor$
    }, formFieldStateExtension, preservedState.formFieldState$);
    const formState$ = createFormState$({
        control$
    }, formStateExtension, preservedState.formState$);
    const globalErrors$ = createGlobalErrors$({
        control$
    }, globalErrorsExtension, preservedState.globalErrors$);
    const baseStreamBag = {
        control$,
        formData$,
        formFieldState$,
        formDescriptor$,
        globalErrors$,
        formState$
    };
    // z feature streamu by asi nebylo vhodne primo subscribovat state streamy pokud chteji nejakou interakci po feature. Lepsi to poslat zase na control
    const extensionParams = [
        baseStreamBag,
        reduxStore,
        name
    ];
    const singleFieldValidation$ = createSingleFieldValidation$(...extensionParams);
    const multipleFieldValidation$ = createMultipleFieldValidation$(...extensionParams);
    const formValidation$ = createFormValidation$(...extensionParams);
    const asyncValidation$ = createAsyncValidations$(...extensionParams);
    const arrayValidationSynchronizer$ = createArrayValidationSynchronizer$(...extensionParams);
    const manualValidationInsert$ = createManualValidationInsert$(...extensionParams);
    const arrayRowValidations$ = createArrayRowValidations$(...extensionParams);
    const manualFocus$ = createManualFocus$(...extensionParams);
    const fieldArrayValidation$ = createFieldArrayValidation$(...extensionParams);
    const clearFieldsErrors$ = createClearFieldsErrors$(...extensionParams);
    const featuresBag = {
        singleFieldValidation$,
        multipleFieldValidation$,
        formValidation$,
        arrayValidationSynchronizer$,
        manualValidationInsert$,
        arrayRowValidations$,
        asyncValidation$,
        manualFocus$,
        fieldArrayValidation$,
        clearFieldsErrors$,
        ...map((ext)=>ext(...extensionParams), featuresExtension)
    };
    const transmission$ = createTransmission$({
        ...baseStreamBag,
        ...featuresBag
    }, transmissionExtension);
    // nektere akce z transmission chci zpristupnit do state streamu.
    // mozna by to chtelo jeste rethinknout ten pristup control/transmission.
    // ale defacto je to takto legitimni reseni
    transmission$.subscribe(control$);
    return {
        ...baseStreamBag,
        ...featuresBag,
        transmission$,
        name,
        formDescriptor,
        streamExtension
    };
});
